(function (obj, type) {
    'use strict';

    angular
        .module('jotApp')
        .controller('CommandsView', CommandsView);

    CommandsView.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity', 'commandsArray', '$rootScope', '$scope', 'TabActions'/*, 'originalTable'*/];

    function CommandsView($state, $uibModalInstance, AlertService, $timeout, entity, commandsArray, $rootScope, $scope, TabActions/*, originalTable*/) {
        var vm = this;

        vm.commandsArray = commandsArray; // contains all the commands (tabActions)
        vm.commands = entity; // contains all the commands that can be assigned a value (formSchemas.forms)
        vm.table = []; // contains all the commands with a value assigned
        vm.tableToExport = []; // contains all the commands with a value assigned

        var isEdit = false;

            /*Pushes every command with an assigned value in the array vm.table*/
            angular.forEach(vm.commands,  function(cmd){
                if(!isCommandValued(cmd)){
                    var command = {name: cmd.command, rowSpan: cmd.form.length}
                    var pos = 0;
                    while(!isCommandValue(cmd.form[pos], command)){
                        pos ++;
                    }
                    vm.table.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                    vm.tableToExport.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                    for(var i = pos+1; i < cmd.form.length; i++){
                        if(!isCommandValue(cmd.form[i],cmd)){
                            vm.table.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd),command: {name:null}});
                            vm.tableToExport.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd),command: {name:null}});
                        }
                    }
                }
            });

            /*Array with every command without an assigned value*/
            var tempCommands;

            tempCommands = vm.commandsArray.filter(function(command){
                return vm.table.findIndex(function (commandInQueue){
                    return command.actionCommand === commandInQueue.command.name
                }) < 0
            });

            /*Array with every command without value, but the objects are structured like in vm.table*/

            vm.notValuedCommands = tempCommands.map(function (oldCommand){
                return {
                    metricName: null,
                    metricValue: null,
                    description: oldCommand.description,
                    command: {
                        name: oldCommand.actionCommand
                    }
                }
            });

            /*vm.table now contains all the commands, with and without assigned values*/
            vm.table = vm.table.concat(vm.notValuedCommands);

        /*Returns the value of a command if it has one*/
        function getValue(form, command){
            return isCommandValue (form, command) ? form.schema.default : command[form.title];
        }

        /*Returns the value of a command */
        function isCommandValue(form, command){
            return command[form.title] === undefined || command[form.title] === null || isNaN(command[form.title]);
        }

        /*Checks if a command has any value assigned, returns a boolean*/
        function isCommandValued(command){
            var check = false;
            var forms = command.form;
            for(var i = 0;  i < forms.length; i++){
                check = check || isCommandValue(forms[i],command)
            }
            return check;
        }

        vm.exportTable = function (type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    tableName: 'Commands Detail',
                    ignoreColumn: [3,4],
                    size: {0: 200, 1: 100, 3: 100}
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({
                    type: type,
                    escape: 'false',
                    tableName: 'Commands Detail',
                    size: {0: 50, 1: 50, 3: 50},
                    ignoreColumn: [3,4],
                });
            }
            vm.tabObjectsToExport = [];
        };

        /*Closes the modal*/
        vm.clear = function () {
            if(isEdit){
                $state.reload();
            }
            $uibModalInstance.dismiss('cancel');
        };

        /*Opens the description editor*/
        vm.enableEditor = function(command) {
            command.isEdit = true;
        };

        /*Closes the description editor and reassigns the value to the one before the modifications*/
        vm.disableEditor = function (command){
            command.isEdit = false;

            var originalCommand;

            originalCommand = vm.commandsArray.find(function (originalCommand){
                return originalCommand.actionCommand === command.command.name;
            })

            command.description = originalCommand.description;
        };

        /*Saves the modified description*/
        vm.saveUpdate = function(command) {
            var originalCommand;

            originalCommand = vm.commandsArray.find(function (originalCommand){
                return originalCommand.actionCommand === command.command.name;
            })

            // assign the new description to the command
            originalCommand.description = command.description;

            TabActions.update(originalCommand, onSuccess, onError);

            function onSuccess() {
                command.isEdit = false;
                isEdit = true;
            }

            function onError(error){
                AlertService.error(error.data.message);
            }
        };

    }
})();
